module.exports = __webpack_public_path__ + "assets/img/up.41d6b1c8.svg";